<template>
    <div style="position: relative;">

        <div style="margin:0 0 5px;display: flex;justify-content:flex-end;width: 100%; ">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addHelp()">新增首页宣传</el-button>
        </div>

        <mytable :tableColums='tableColums_getAjHomePublicizeList' api='getAjHomePublicizeList'
            updateapi='updateSysHelp' :height="H - 158">
            <icol slot='ahpCover' :showtooltip='false' img='ahpCover' />
            <div slot="ahpTitle" slot-scope="{row}" v-text="row.ahpTitle" style="white-space:normal;line-height:1.8;">
            </div>
            <div slot="ahpDetails" slot-scope="{row}" v-html="row.ahpDetails"
                style="max-height: 30vh;overflow: hidden;max-width: 99%;"></div>
        </mytable>
        <myform view.updateAjHomePublicize></myform>
        <myform view.tinymce='富文本编辑器 - 全屏: 双击或点击最后一个按钮#el-icon-circle-check#保存' id="PromotionManage" width='85%'
            top='50px' @closed='row = null' opened="$event.title = row.skRemark + ' - 全屏: 双击或点击最后一个按钮'"
            @close='arguments[1] && (arguments[0].actived = "",ahpCover="")'
            @show='boolean = true, superEditor && superEditor.show(window.sleep(400, v => superEditor.focus()))'
            @confirm='superEditorUpload'>
            <!-- <div v-if='boolean'>{{ window.alert(5555) }}</div> -->
            <div style="width: 100%;height: 600px;overflow-y: auto;">
                <el-input placeholder="请输入标题" v-model="input" clearable size="medium" style="width:100%;"></el-input>
                <el-input placeholder="请输入排序" v-model="ahpOrder" clearable size="medium" style="width:100%;"></el-input>
                <p>是否发布:</p>
                <el-select v-model='ahpStatus' clearable filterable placeholder="是否确认发布" size="medium">
                    <el-option label="否" :value="1"> </el-option>
                    <el-option label="是" :value="2"> </el-option>
                </el-select>
                <div>
                    <p>封面:</p>
                    <p>
                        <myupload v-event.fileUpload='`
                      return (ahpCover+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? ahpCover = C : false )
                    `' @change='ahpCover = ($file$ = arguments[0]).url' @remove='window.sleep(150, v => ahpCover = "")'
                            type='image' :limit='1' :params='{ file: "$file$" }' :filelist='ahpCover
                ? ({ name: ahpCover, url: ahpCover })
                : false
                ' :style="{ height: ahpCover && $form('updateAjHomePublicize', 'ifshow') ? '250px' : '' }">
                        </myupload>
                    </p>

                </div>
                <div v-if='boolean'>
                    <tinymce v-model='string' xreadonly v-s.height='H - 180' id='tinymce'></tinymce>
                </div>
            </div>

        </myform>
        <!-- <myformtwo
      style="width: 100%; height: 100%;">
      <h2 slot='one' slot-scope='user' >
       {{user.data}}
        </h2>
  
      </myformtwo> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            input: "",
            ahpOrder: '',
            ahpCover: '',
            userId: null,
            ahpStatus:'',
            tableColums_getAjHomePublicizeList: {
                $selection: false,
                ahpTitle: ['标题', 200,],
                ahpCover: ['封面', 200,],
                ahpDetails: '内容',
                ahpOrder: ["排序", 80],
                ahpStatus: ['状态', , '@v-if: 1:待发布#danger, 2:已发布#success'],
                $operation: this.updateAjHomePublicize && [
                    '操作', 180,

                    this.updateAjHomePublicize && `@text: 编辑#warn
              @click:
                $row.skId == 1
                ? $form("updateAjHomePublicize",$row)
                : ( $form('tinymce'), string = ($this.row=$row).ahpDetails + '',input =($this.row=$row).ahpTitle,
                ahpCover=($this.row=$row).ahpCover,ahpOrder=($this.row=$row).ahpOrder,ahpStatus =($this.row=$row).ahpStatus )
            `,
                    this.deleteAjHomePublicize && `@text:删除#danger+
              @click: dodel($row)
            `,
             this.deleteAjHomePublicize && `@text:发布#danger+
              @click: goFabulous($row) `,
              this.deleteAjHomePublicize && `@text:下架#warn+
              @click: goFabulousUn($row) `,
                ],
            },

        };
    },

    watch: {
        superEditor(superEditor) {
            superEditor.focus();
        },
    },

    methods: {
        async goFabulous(row){
            if (!await this._confirm('你确认要发布这条首页宣传吗?')) return;
            this.updateAjHomePublicizeStatus({
                ahpId: row.ahpId,
                ahpStatus: 2,
            }, '正在处理').result(res => {
                if (!res) return;
                alertSuccess('发布成功!');
                this.getAjHomePublicizeList();
            });
        },
        async goFabulousUn(row){
            if (!await this._confirm('你确认要下架这条首页宣传吗?')) return;
            this.updateAjHomePublicizeStatus({
                ahpId: row.ahpId,
                ahpStatus: 1,
            }, '正在处理').result(res => {
                if (!res) return;
                alertSuccess('下架成功!');
                this.getAjHomePublicizeList();
            });
        },
        addHelp() {
            this.input = this.string = this.ahpOrder = this.ahpCover = '';
            $form('tinymce');
        },
        async dodel(row) {
            if (!await this._confirm('你确认要删除这条首页宣传吗?')) return;
            this.deleteAjHomePublicize({
                ahpId: row.ahpId
            }, '正在删除').result(res => {
                if (!res) return;
                alertSuccess('删除成功!');
                this.getAjHomePublicizeList();
            });
        },
        async superEditorUpload() {
            if (this.input == "" || this.string == "" || this.ahpCover == "" || this.ahpOrder == "") {
                return this.$message({
                    showClose: true,
                    message: '标题,内容,封面,排序不能为空',
                    type: 'error'
                });
            };
            var html = await this.superEditor.upload(document.body); // this.$refs.reward.$el.firstElementChild
            if (html !== html) return;
            var img = this.ahpCover
            const res = await this.$trigger("fileUpload").trigger(res => {
                this.ahpCover = res;
                if (!this.row) {

                    this.addAjHomePublicize({
                        ahpTitle: this.input,
                        ahpCover: this.ahpCover,
                        ahpDetails: html,
                        ahpOrder: this.ahpOrder,
                        ahpStatus: this.ahpStatus,
                    }, '正在提交').result(res => {
                        if (!res) return;
                        alertSuccess('新增成功!');
                        this.$form('tinymce', 'hide');
                        this.getAjHomePublicizeList();
                    });
                } else {
                    if (this.ahpCover == true) {
                        this.ahpCover = img
                    }
                    this.updateAjHomePublicize({
                        ahpId: this.row.ahpId,
                        ahpTitle: this.input,
                        ahpCover: this.ahpCover,
                        ahpDetails: html,
                        ahpOrder: this.ahpOrder,
                        ahpStatus: this.ahpStatus,
                    }, '正在更新').result(res => {
                        if (!res) return;
                        alertSuccess('更新成功!');
                        this.$form('tinymce', 'hide');
                        this.getAjHomePublicizeList();
                    });
                };
            })
            //console.log(html);



        },
    },

    created() {
        // console.warn(1);
        this.getAjHomePublicizeList();
    },

};
</script>


<style>
#PromotionManage>.el-dialog__wrapper,
#PromotionManage>.el-dialog__wrapper>[fullscreen] {
    overflow: hidden !important;
}

#PromotionManage [fullscreen] #tinymce {
    height: 90vh !important;
}

#PromotionManage .el-dialog__body {
    padding-top: 7px !important;
    padding-bottom: 0 !important;
}

#PromotionManage .el-dialog__footer {
    padding: 0px 27px 25px !important;
}

#PromotionManage .el-button {
    position: absolute;
    top: 15px;
    right: 60px;
    border-radius: 50px;
    z-index: 777;
}
</style>


// WEBPACK FOOTER //
// src/views/bussiness/HomePagePublicize.vue